import React from 'react';
import '../styles/PropertyLinks.css';

function PropertyLinks(props) {
    const property = props.property;
    const darkMode = props.darkMode;
    
    const viewLink = (url) => {
        window.open(url, "_blank");
    };

    return (
        <div className="property-links-container">
            {
                property.propertyUrls.zillowUrl !== null &&
                <span 
                    className={"label-regular underline cursor-pointer " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}
                    onClick={() => viewLink(property.propertyUrls.zillowUrl)}
                >
                    Zillow
                </span>
            }
            <span className={"label-regular " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}>
                •
            </span>
            {
                property.propertyUrls.realtorUrl !== null &&
                <span 
                    className={"label-regular underline cursor-pointer " + (darkMode === true ? "colour-tertiary" : "colour-secondary")}
                    onClick={() => viewLink(property.propertyUrls.realtorUrl)}
                >
                    Realtor
                </span>
            }
        </div>
    )
};

export default PropertyLinks;